'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import type { NoMessageValues, MessageValue } from 'react-intl';
import { useAiSummaryTracking } from '../../../Tracking/hooks/useAiSummaryTracking/useAiSummaryTracking';
import { DislikeIcon } from './Dislike.icon';
import { LikeIcon } from './Like.icon';

const messages = defineMessages<{
  readonly positive: { readonly isSelected: MessageValue };
  readonly negative: { readonly isSelected: MessageValue };
  readonly selected: NoMessageValues;
}>({
  positive: {
    defaultMessage: 'Diese Zusammenfassung als hilfreich bewerten {isSelected}',
    id: 'customerratings.aisummary.rating.positive',
  },
  negative: {
    defaultMessage: 'Diese Zusammenfassung als nicht hilfreich bewerten {isSelected}',
    id: 'customerratings.aisummary.rating.negative',
  },
  selected: {
    defaultMessage: '(ausgewählt)',
    id: 'customerratings.aisummary.rating.positive.selected',
  },
});

export const RateAiSummary = () => {
  const { formatMessage } = useIntl();
  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);

  const { trackGlycerinAIRatingClick, trackGlycerinDisplayFeature } = useAiSummaryTracking();

  useEffect(() => {
    trackGlycerinDisplayFeature();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-x-1">
      <Button
        variant="icon-flat"
        className="disabled:opacity-100"
        size="large"
        disabled={isLiked}
        onClick={() => {
          trackGlycerinAIRatingClick({ detail: 'Positiv' });
          setIsLiked(true);
          setIsDisliked(false);
        }}
        aria-label={formatMessage(messages.positive, {
          isSelected: isLiked ? formatMessage(messages.selected) : '',
        })}
      >
        <LikeIcon className={isLiked ? 'thumb-icon-active' : 'thumb-icon'} />
      </Button>
      <Button
        variant="icon-flat"
        className="disabled:opacity-100"
        size="large"
        disabled={isDisliked}
        onClick={() => {
          trackGlycerinAIRatingClick({ detail: 'Negativ' });
          setIsDisliked(true);
          setIsLiked(false);
        }}
        aria-label={formatMessage(messages.negative, {
          isSelected: isDisliked ? formatMessage(messages.selected) : '',
        })}
      >
        <DislikeIcon className={isDisliked ? 'thumb-icon-active' : 'thumb-icon'} />
      </Button>
    </div>
  );
};
